import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Login from '../Login';
import { LoginCallback } from '../../components/HeaderLogin/callback';
import { SilentRenew } from '../../components/HeaderLogin/silent_renew';
import ContractConfirm from '../../components/ContractConfirm';
import App from '../App/App';
import Download from '../Download';
import PrivacyPolicy from '../PrivacyPolicy';
import TermsAndConditions from '../TermsAndConditions';
import NotFound from '../../components/NotFound';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

import { getIsLogged, getAccessToken } from '../../components/HeaderLogin/selectors';

const Routing = () => {
  const isLogged = useSelector(getIsLogged);
  const accessToken = useSelector(getAccessToken);
  const { t, i18n } = useTranslation();

  const checkIsLogged = (Component, routerProps) => {
    return isLogged ? <Redirect to='/contract' /> : <Component {...routerProps} t={t} i18n={i18n} />;
  };

  const requireAuth = (Component, routerProps) => {
    if(isLogged) {
      return <Component {...routerProps} t={t} i18n={i18n} accessToken={accessToken} />;
    } else {
      // const urlstate = window.location.href.replace(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`, '');
      return <Redirect to={{
        pathname: '/',
        // state: urlstate
      }} />;
    }
  };

  const routes = <Switch>
    <Route exact path='/' component={checkIsLogged.bind(this, Login)} />
    <Route exact path='/callback' component={checkIsLogged.bind(this, LoginCallback)} />
    <Route exact path='/silent_renew' component={requireAuth.bind(this, SilentRenew)} />
    <Route exact path='/contract' component={requireAuth.bind(this, App)} />
    <Route exact path='/contract-confirm' component={requireAuth.bind(this, ContractConfirm)} />
    <Route path='/download/:iddocument' component={requireAuth.bind(this, Download)} />
    <Route path='/privacy-policy' component={PrivacyPolicy} />
    <Route path='/terms-and-conditions' component={TermsAndConditions} />
    <Route path='*' component={() => <NotFound t={t} />} />
  </Switch>;

  return <BrowserRouter>
    <div className='container-fluid'>
      <div className='row'>
        <div className='col'>
          <Header t={t} i18n={i18n}></Header>
        </div>
      </div>
      {routes}
      <div className='row'>
  			<div className='col no-padding'>
  				<div className='login-help mt-5'>
  					<div className='help-container position-absolute'>
  						<div className='phone'>800.92.22.00</div>
  						<div className='text'>{t('help.text')}</div>
  					</div>
  				</div>
  			</div>
  		</div>
      <div className='row'>
        <div className='col'>
          <Footer></Footer>
        </div>
      </div>
    </div>
  </BrowserRouter>;
};

export default Routing;
